import AllHobbies from "../../../../src/components/hobbies/all-hobbies";
import * as React from 'react';
export default {
  AllHobbies,
  React
};